import React from 'react'

const LoyaltyPointIcon = (<svg xmlns='http://www.w3.org/2000/svg' width='100' height='85' viewBox='0 0 71 69'><g><g><path fill='#fab900' d='M35.469 14.688c12.547 0 22.718 10.409 22.718 23.25 0 12.84-10.171 23.25-22.718 23.25S12.75 50.778 12.75 37.938c0-12.841 10.172-23.25 22.719-23.25z' /></g><g><path fill='#fff' d='M37.985 45L38 41h6v-9h-9.985L34 36h-6v9zM40 43v4H26V34h6v-4h14v13z' /></g></g></svg>)

export default LoyaltyPointIcon
